import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const isFor = ['Mujeres profesionales y madres que se sienten "secas" o desconectadas de su cuerpo.', 'Mujeres que aman a sus parejas pero sienten que la intimidad es una tarea pendiente en su lista.', 'Aquellas que sufren de fatiga sensorial y sienten invasión ante el contacto físico.', 'Mujeres que quieren recuperar su magnetismo y presencia sin recurrir a técnicas artificiales.'];
const isNotFor = ['Personas que buscan soluciones mágicas de una noche sin compromiso con su práctica diaria.', 'Parejas en situaciones de crisis de violencia o abuso profundo (requiere terapia clínica).', 'Quienes no estén dispuestas a dedicar 15 minutos diarios a su propia calma.'];
export function WhoIsForSection() {
  return <section className="py-12 px-6 bg-blush-light" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-161">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-cream p-8 md:p-12 rounded-sm shadow-sm border border-gold/20" data-id="element-162">
            <h3 className="text-2xl md:text-3xl font-playfair text-burgundy-deep mb-8 border-b border-gold/30 pb-4" data-id="element-163">
              Para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-164">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-165">
                  <div className="flex-shrink-0 mt-1" data-id="element-166">
                    <CheckIcon className="w-5 h-5 text-gold" data-id="element-167" />
                  </div>
                  <p className="text-charcoal/80 leading-relaxed" data-id="element-168">{item}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-cream/50 p-8 md:p-12 rounded-sm border border-mauve/20" data-id="element-169">
            <h3 className="text-2xl md:text-3xl font-playfair text-charcoal/60 mb-8 border-b border-mauve/30 pb-4" data-id="element-170">
              No es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-171">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-172">
                  <div className="flex-shrink-0 mt-1" data-id="element-173">
                    <XIcon className="w-5 h-5 text-mauve" data-id="element-174" />
                  </div>
                  <p className="text-charcoal/60 leading-relaxed" data-id="element-175">{item}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}